import { render, staticRenderFns } from "./ResultsTrouble.vue?vue&type=template&id=a4cb5484"
import script from "./ResultsTrouble.vue?vue&type=script&lang=js"
export * from "./ResultsTrouble.vue?vue&type=script&lang=js"
import style0 from "./ResultsTrouble.vue?vue&type=style&index=0&id=a4cb5484&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports